module.exports = __webpack_public_path__ + "img/bg_top_new.fbb9c40f.png";